export default "__VITE_ASSET__CxwDi9uv__"